import { render, staticRenderFns } from "./PDFMovimientos.vue?vue&type=template&id=1671fd3a&"
import script from "./PDFMovimientos.vue?vue&type=script&lang=js&"
export * from "./PDFMovimientos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports